export const firebaseConfig = {
    apiKey: "AIzaSyDAB92OnyCe3MmW5NJOGC-hwHJy9km5kf4",
    authDomain: "vert-farm-api.firebaseapp.com",
    projectId: "vert-farm-api",
    storageBucket: "vert-farm-api.appspot.com",
    messagingSenderId: "356256003325",
    appId: "1:356256003325:web:c879ce42ca46d1c876fa94"
};

export const algoliaId = process.env.REACT_APP_ALGOLIA_ID || 'B1UL306WKY';
export const algoliaKey = process.env.REACT_APP_ALGOLIA_KEY || 'e8ad314432f46c505f7fe5e323b9efc4';
